import i18n from '@/lang';
// 业务类型-与其他数值不同
export const BUSINESS_TYPE = Object.freeze({
  0: {
    label: i18n.t('collectionCenter.expressDelivery'), // 快递
    value: 0
  },
  1: {
    label: i18n.t('collectionCenter.collect'), // 揽收
    value: 1
  }
});

// 发票状态
export const INVOICE_STATUS = {
  1: {
    label: i18n.t('receivablePayable.Generated'), // 已生成
    value: 1
  },
  2: {
    label: i18n.t('GlobalSetObj.Canceled'), // 已取消
    value: 2
  },
  3: {
    label: i18n.t('mdfeTranslate.OperationFailed'), // 操作失败
    value: 3
  },
  4: {
    label: i18n.t('mdfeTranslate.PendingReview'), // 待审核
    value: 4
  },
  5: {
    label: i18n.t('mdfeTranslate.Unprocessed'), // 未处理
    value: 5
  },
  6: {
    label: i18n.t('mdfeTranslate.InProgress'), // 进行中
    value: 6
  }
};

